module.exports = __webpack_public_path__ + "img/person-email.3b38b53c.svg";